import React from "react";
import { createRoot } from "react-dom/client";
import { useWidgetProps } from "../use-widget-props";
import { useOpenAiGlobal } from "../use-openai-global";
import { CheckIcon, XIcon, BackgroundIcon } from "./icons";

function App() {
  const props = useWidgetProps({
    success: true,
  });

  const theme = useOpenAiGlobal("theme") || "light";

  const isDark = theme === "dark";

  return (
    <div
      className={`antialiased w-full overflow-hidden rounded-3xl ${
        isDark
          ? "bg-[#212121] border border-white-alpha-20"
          : "bg-white border border-black-alpha-15"
      }`}
      style={{ boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)" }}
    >
      <div className="flex flex-col items-center gap-8 p-16">
        {/* Icon */}
        <div className="relative flex items-center justify-center flex-shrink-0">
          <BackgroundIcon color={props.success ? "#008241" : "#E02E2A"} />
          <div className="absolute top-0 right-0 w-full h-full p-12 flex items-center justify-center">
            {props.success ? <CheckIcon /> : <XIcon />}
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-col justify-center items-center">
          <div
            className={`font-medium text-[17px] leading-[1.35em] tracking-[-1.29%] ${
              isDark ? "text-[#FFFFFF]" : "text-[#000000]"
            }`}
          >
            {props.success
              ? "History successfully deleted"
              : "Failed to delete history"}
          </div>
          <div
            className={`font-regular text-[14px] leading-[1.42em] tracking-[-2%] ${
              isDark ? "text-[#CDCDCD]" : "text-[#5D5D5D]"
            }`}
          >
            {props.success
              ? "The history has been permanently removed."
              : "The history failed to delete, Please try again."}
          </div>
        </div>
      </div>
    </div>
  );
}

// Mount the app
const rootElement = document.getElementById("humanizer-delete-result-root");
if (rootElement) {
  createRoot(rootElement).render(<App />);
}

export default App;
